import WidgetInfo from './WidgetInfo';
export default WidgetInfo;
